import React, { FC, ReactText } from 'react';
import { CheckSign } from 'components';

interface DetailsLeftProps {
  title: string;
  docTitle?: string;
  docs?: React.ReactNode[];
  detailsList: {
    title: string;
    value: string | number | ReactText | JSX.Element;
  }[][];
}

const DetailsLeft: FC<DetailsLeftProps> = ({
  title,
  docTitle,
  docs,
  detailsList,
}) => (
  <div className="details__col">
    <h2 className="text-2 details__title">{title}</h2>
    <div className="details__list__container">
      {detailsList.map((detail) => (
        <div className="details__list__col">
          {detail.map(
            (
              d: {
                title: string;
                value: string | number | ReactText | JSX.Element;
              },
              index: number
            ) => (
              <div
                className="details__list__item"
                key={`details__list__item-${index}`}
              >
                <div className="details__list__item__title">{d.title}</div>
                <div className="details__list__item__text">{d.value}</div>
              </div>
            )
          )}
        </div>
      ))}
    </div>
    {!!docs?.length && (
      <>
        <h2 className="text-2 details__title">{docTitle}</h2>
        <div className="details__list-doc">{docs.map((doc) => doc)}</div>
        <CheckSign />
      </>
    )}
  </div>
);

export default DetailsLeft;
